import Typography from '@alltrails/shared/denali/components/Typography';
import Expandable from '@alltrails/shared/components/Expandable';
import * as styles from './styles/styles.module.scss';
import FooterLinksType from '../../../utils/generators/FooterLinksType';

const ExpandableFooterLink = ({ href, title, logAmplitudeEvent, childLinks = [] }: FooterLinksType) => (
  <Expandable
    title={
      <a
        data-testid={title}
        href={href}
        onClick={() => {
          if (logAmplitudeEvent) {
            logAmplitudeEvent();
          }
        }}
      >
        <Typography component="h2" variant="heading300" color="inverse">
          {title}
        </Typography>
      </a>
    }
  >
    <ul>
      {childLinks.map(link => (
        <li key={link.title} className={styles.listItem}>
          <a
            data-testid={link.title}
            href={link.href}
            onClick={() => {
              if (link.logAmplitudeEvent) {
                link.logAmplitudeEvent();
              }
            }}
          >
            {link.title}
          </a>
        </li>
      ))}
    </ul>
  </Expandable>
);

export default ExpandableFooterLink;
